module.exports = __webpack_public_path__ + "static/media/ilus-services-interaction-design.b0fe2c55.svg";